"use client";

import AmpService, { AMP_CATEGORY_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classNames from "classnames";
import styles from "./department-menu.module.scss";

const DepartmentMenuParent = (props) => {
  const { children, onSelectItem, department } = props;

  const handleClickDepartment = (selectedDepartment: any) => {
    AmpService.categoryClick({ tier0: selectedDepartment.name }, AMP_CATEGORY_LOCATIONS.DEPARTMENT_MENU);
    if (onSelectItem) {
      onSelectItem(selectedDepartment);
    }
  };

  return (
    <div
      className={classNames(styles.department_item_bg, {
        clearfix: onSelectItem,
        [styles.department_item]: onSelectItem,
      })}
      key={`depicon_${department.id}`}
      onClick={() => handleClickDepartment(department)}
    >
      {children}
    </div>
  );
};

export default DepartmentMenuParent;
